import {Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {
    buildMsisdnFraudEntryControls,
    MsisdnFraudEntryForm,
} from '../msisdn-fraud-form/msisdn-fraud-form.component';

@Component({
    selector: 'af-msisdn-fraud-expansion-panel',
    templateUrl: './msisdn-fraud-expansion-panel.component.html',
    styleUrl: './msisdn-fraud-expansion-panel.component.scss',
    standalone: false,
})
export class MsisdnFraudExpansionPanelComponent implements OnInit {
    @Input() form: FormGroup<MsisdnFraudEntryForm>;
    @Input() index: number;
    @Input() hasDeleteButton: boolean;
    @Input() hasAddEntryButton: boolean;
    @Input() isAddEntryButtonDisabled: boolean;
    @Output() deleteEntryListener = new EventEmitter<number>();
    @Output() addNewEntryListener = new EventEmitter<void>();

    private destroyRef = inject(DestroyRef);
    private formBuilder = inject(FormBuilder);

    private _expanded = false;
    private wasExpanded = false;

    get expanded(): boolean {
        return this._expanded;
    }

    @Input()
    set expanded(value: boolean) {
        if (value) {
            this._expanded = true;
            this.wasExpanded = true;
        } else {
            if (!this.wasExpanded) {
                this._expanded = false;
            }
        }
    }

    ngOnInit(): void {
        buildMsisdnFraudEntryControls(this.form, this.formBuilder, this.destroyRef);
    }
}
